module.exports = __webpack_public_path__ + "static/media/patient_waiting.0c23dde9.wav";